import { HttpClient, HttpContext } from "@angular/common/http";
import { computed, inject, signal } from "@angular/core";
import { Router } from "@angular/router";
import { AUTH_DAVESA_API } from "app/core/auth-davesa/auth-davesa-api.component";
import { AuthDavesaV2Service } from "app/core/auth-davesa/auth-davesa-v2.service";
import { User } from "app/core/interfaces/user.interface";
import { EncryptStorage } from "encrypt-storage";
import { environment } from "environments/environment";
import { createInjectable } from "ngxtension/create-injectable";
import { tap } from "rxjs";
import { Shortcut } from "./shortcut.model";
import { Update } from "app/core/interfaces/generics/update.interface";
import { List } from "app/core/interfaces/generics/list.interface";
import { Delete } from "app/core/interfaces/generics/delete.interface";
import { GetOne } from "app/core/interfaces/generics/getOne.interface";

export const encryptStorage = new EncryptStorage(
  environment.ENCRYPT_STORAGE_KEY,
  {
    storageType: "sessionStorage",
  }
);

const USER = "user";
const USERS = "users";
const ALL_USERS = "allUsers";
const LOGIN_USER = "loginUser";

const httpOptions = {
  context: new HttpContext().set(AUTH_DAVESA_API, true),
};

export const ShortcutV2Service = createInjectable(() => {
    const _router = inject(Router);
    const _httpClient = inject(HttpClient);
    const _authDavesaService = inject(AuthDavesaV2Service);
    const shortcuts = signal<Shortcut[] | null>(null);
    const shortcut = signal<Shortcut | null>(null);
    const loginUser = signal<User | null>(null);

    const loading = signal(false);
    const error = signal<string | null>(null);

    const createItem = (data: Shortcut) => {
      loading.set(true);
      error.set(null);
      return _httpClient
        .post<Update<Shortcut>>("user/user-setting/create", data, httpOptions)
        .pipe(
          tap({
            next: (res: Update<Shortcut>) => {
              console.log("🚀 ~ createItem ~ res:", res);
              if (res.data) {
                // shortcut.set(res.data);
              }
            },
            error: (err) => {
              console.log("err", err);
              error.set(err);
              loading.set(false);
            },
          })
        );
    };

    const getAll = () => {
      loading.set(true);
      error.set(null);
      return _httpClient
        .get<List<Shortcut>>("user/user-setting/list", httpOptions)
        .pipe(
          tap({
            next: (res: List<Shortcut>) => {
              if (res.data) {
                shortcuts.set(res.data);
                encryptStorage.setItem("shortcuts", res.data)
                loading.set(false);
                return res.data;
              }
            },
            error: (err) => {
              console.log("err", err);
              error.set(err);
              loading.set(false);
            },
          })
        );
    };

    const updateItem = (data) => {
      loading.set(true);
      error.set(null);
      return _httpClient
        .put<Update<Shortcut>>("user/user-setting/update", data, httpOptions)
        .pipe(
          tap({
            next: (res: Update<Shortcut>) => {
              if (res) {
                console.log("updateItem", res);
              }
            },
            error: (err) => {
              console.log("err", err);
              error.set(err);
              loading.set(false);
            },
          })
        );
    };

    const deleteItem = (oid: string) => {
      loading.set(true);
      error.set(null);
      return _httpClient
        .delete("user/user-setting/delete/" + oid, httpOptions)
        .pipe(
          tap({
            next: (res: Delete<Object>) => {
              if (res.data) {
                // shortcut.set(res.data);
              }
            },
            error: (err) => {
              error.set(err);
              loading.set(false);
            },
          })
        );
    };

    const deleteAllShortcuts = () => {
      loading.set(true);
      error.set(null);
      return _httpClient
        .delete("user/user-setting/deleteall", httpOptions)
        .pipe(
          tap({
            next: (res) => {
              
            },
            error: (err) => {
              error.set(err);
              loading.set(false);
            },
          })
        );
    };

    return {
      user: computed(() => shortcut()),
      users: computed(() => shortcuts()),
      createItem,
      getAll,
      updateItem,
      deleteItem,
      deleteAllShortcuts,
    };
})
